import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import StarRateIcon from '@material-ui/icons/StarRate';

const styles = (theme) => ({
    rating: {
        fill: '#fad043',
        marginRight: '5px'
    },
    root: {
        display: 'flex',
        alignItems: 'center'
    }
});

const Ratings = ({ classes, rating, ratingCount }) => {
    return (<div className={classes.root}>
        <StarRateIcon fontSize="small" classes={{ root: classes.rating }} />
        <strong>{rating}</strong>
        ({ratingCount})
    </div>);
}

export default withStyles(styles)(Ratings);
